import { Component, signal } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SessionService } from '../../../services/session-service';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { SnackBarService } from '../../../services/snack-bar-service';

@Component({
  selector: 'app-create-session-modal-component',
  imports: [MatDialogModule, MatButtonModule, MatInputModule, MatFormFieldModule, MatIconModule, FormsModule],
  templateUrl: './create-session-modal-component.html'
})
export class CreateSessionModalComponent {
  sessionName: any;
  canCreateSession = signal(true);

  constructor(
    private sessionService: SessionService,
    private readonly snackbar: SnackBarService,
    private readonly router: Router,
    private dialogRef: MatDialogRef<CreateSessionModalComponent>
  ) {}

  createSession() {
    this.canCreateSession.set(false);
    this.sessionService.createSession(this.sessionName).subscribe({
      next: (session) => {
        // Redirect user to new session and close dialog
        this.snackbar.success(`Session ${session.code} créée !`); 
        this.router.navigate(['/sessions', session.code]);
        this.close(true);
      },
      error: () => {
        // Error encountered when creating session
        this.snackbar.error("Erreur rencontrée.")
        this.canCreateSession.set(true);
      }
    });
  }

  close(result: boolean) {
    this.dialogRef.close(result);
  }
}
